export default {
  path: '/v5/matchmaking/lobby/:id',
  name: 'V5MatchmakingLobby',
  component: () => import('./LobbyPage.vue'),
};
